import React, { Component, createRef } from "react";
import Label from "../Label/Label";
import T from "../t/T";
import "./CheckBox.scss";
import {connect} from "react-redux";
import snippets from "../../../helpers/snippets";

class CheckBox extends Component {
  constructor(props) {
    super(props);

    // Refs
    this.checkboxRef = createRef();

    this.state = {
      checked: this.props?.checked ?? false,
      language: this.props.language
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.checked !== this.props.checked) {
      this.setState({ checked: this.props.checked });
    }
    if (prevProps.language !== this.props.language) {
      this.setState({ language: this.props.language });
    }
  }

  handleCheckboxChange = (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (this.props?.disabled) return

    this.setState({
      checked: !this.state.checked
    },() => {
      // Only pass option name and value.
      this.props.handleChangeValue({
        name: this.checkboxRef.current.name,
        value: this.checkboxRef.current.value,
        checked: this.state.checked
      });
    });
  }

  renderSimpleCheckBox = (inputName="", value, tabIndex, disabled) => {
    return <div className={`checkbox-face ${disabled ? "disabled" : ""}`} onClick={this.handleCheckboxChange}>
      {this.state.checked && <i className="fa-regular fa-check" />}
      <input type="checkbox" name={inputName} checked={this.state.checked} value={value ?? ""} onChange={() => {}} ref={this.checkboxRef} tabIndex={tabIndex}/>
    </div>;
  }

  renderComplexCheckBox = (inputName="", rawText, rawStyles, value, labelText, tooltip = null, tooltipWithIcon = null, customClass = "", labelDir = "rtl", icon = null, transparent, tabIndex, disabled) => {
    return <div className={`checkbox__complex-container ${ this.state.checked ? "active" : "" } ${transparent ? "transparent" :"" } ${customClass} ${disabled ? "disabled" : ""}`} title={tooltip} onClick={this.handleCheckboxChange}>
      { this.renderSimpleCheckBox(inputName, value, tabIndex, disabled) }
      <span className={`checkbox__complex-container__title ${labelDir} ${disabled ? "disabled" : ""}`} >
        <span className={"checkbox__complex-container__title__text"} >
          {(rawText && rawStyles) && <span style={{...rawStyles, padding: "0 2px", margin: "0 4px"}} >{rawText}</span>}
          <span > <T token={labelText}/> </span>
        </span>
        {!snippets.isObjectEmpty(tooltipWithIcon) && (icon && <i className={icon} title={tooltipWithIcon}/>)}
      </span>
    </div>;
  }

  render() {
    const {name = "", labelText = null, value = null, type="simple", disableMainLabel = false,
      customClass = "", labelDir = "rtl", icon = null, tooltip = null, tooltipWithIcon = null,
      transparent = false, tabIndex, disabled = false, rawText= "", rawStyles = null} = this.props;
    let renderedCheckBox = null;

    switch(type.toLowerCase()) {
      case "simple":
        renderedCheckBox = this.renderSimpleCheckBox(name, value, tabIndex, disabled);
        break;
      case "complex":
        renderedCheckBox = this.renderComplexCheckBox(name, undefined, undefined, value, labelText, tooltip, tooltipWithIcon, customClass, labelDir, icon, transparent, tabIndex, disabled);
        break;
      case "complex_styled":
        renderedCheckBox = this.renderComplexCheckBox(name, rawText, rawStyles, value, labelText, tooltip, tooltipWithIcon, customClass, labelDir, icon, transparent, tabIndex, disabled);
        break;
      default:
        renderedCheckBox = "Wrong type for element entered!!!";
        break;
    }

    return <div className={`checkbox-input`}>
      {(labelText && !disableMainLabel) && <Label labelText={labelText} />}
      {
        renderedCheckBox
      }
    </div>;
  }
}

const mapStateToProps = state => {
  const language = state.LangReducer.language;
  return {language};
}

export default connect(mapStateToProps)(CheckBox);